var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulseSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2C0,0.896,0.896,0,2,0z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2,0h12c1.104,0,2,0.896,2,2v12c0,1.104-0.896,2-2,2H2c-1.104,0-2-0.896-2-2V2C0,0.896,0.896,0,2,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    width: 16,
    height: 16
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-133.000000, -149.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PulseChain-Logo-Shape_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -357.8071,
    y1: 656.4629,
    x2: -357.8209,
    y2: 656.4406,
    gradientTransform: "matrix(432.0988 0 0 -400.6515 154751.9063 263165.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    style: {
      stopColor: "#0080FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4974,
    style: {
      stopColor: "#8000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7499,
    style: {
      stopColor: "#E619E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    style: {
      stopColor: "#FF0000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "PulseChain-Logo-Shape",
    fill: "url(#PulseChain-Logo-Shape_1_)",
    d: "M146.643,157.604c0,0.053-0.012,0.104-0.035,0.148 l-2.42,4.192c-0.104,0.178-0.293,0.287-0.498,0.287h-5.378c-0.206,0-0.396-0.109-0.498-0.287l-2.421-4.192 c-0.023-0.044-0.036-0.096-0.036-0.148c0-0.174,0.141-0.314,0.314-0.314h2.655l0.673,1.144l0.004,0.006 c0.09,0.145,0.279,0.191,0.426,0.105l0,0l0.008-0.005c0.068-0.043,0.117-0.11,0.137-0.188l0,0l0.857-3.314l0.736,5.337 l0.001,0.007c0.027,0.168,0.184,0.284,0.354,0.261l0,0l0.008-0.001c0.121-0.02,0.221-0.11,0.253-0.231l0,0l1.034-3.996 l0.424,0.721l0.004,0.008c0.057,0.092,0.158,0.147,0.266,0.147l0,0h2.816l0,0C146.502,157.29,146.643,157.431,146.643,157.604z  M143.689,151.768c0.205,0,0.395,0.109,0.498,0.288l2.42,4.191c0.023,0.044,0.035,0.096,0.035,0.149 c0,0.173-0.141,0.313-0.314,0.313h-2.664l-0.672-1.143l-0.006-0.008c-0.042-0.068-0.109-0.117-0.187-0.138l0,0l-0.008-0.001 c-0.165-0.039-0.333,0.061-0.375,0.227l0,0l-0.858,3.315l-0.736-5.338l-0.001-0.007c-0.02-0.123-0.11-0.223-0.231-0.254 c-0.168-0.043-0.339,0.058-0.383,0.226l0,0l-1.034,3.996l-0.424-0.721l-0.004-0.008c-0.057-0.091-0.158-0.147-0.267-0.147l0,0 h-2.807l0,0c-0.174,0-0.314-0.141-0.314-0.313c0-0.054,0.012-0.104,0.035-0.147l2.421-4.193c0.102-0.179,0.292-0.288,0.498-0.288 H143.689z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseSquareLogo);
export default __webpack_public_path__ + "static/media/pulse_square_logo.e64a72f42ae218e56570ccac124230b3.svg";
export { ForwardRef as ReactComponent };